
import config from './config/config.json';
// import $ from 'jQuery';
export default {
    appConfig:null,
    getConfig(){
       return config;
    },

    getRealPath(isProjectName){
        isProjectName = (isProjectName == undefined ) ? false : isProjectName;
        //获取当前网址，如： http://localhost:8083/myproj/view/ahha.jsp
        var curWwwPath=window.document.location.href;
        var realPath;
        if(curWwwPath.indexOf("#") != -1){//hash模式
            realPath = window.document.location.origin;
        }else{
            //获取主机地址之后的目录，如： myproj/view/ahha.jsp
            var pathName=window.document.location.pathname;
            var pos=curWwwPath.indexOf(pathName);
            //获取主机地址，如： http://localhost:8080
            var localhostPaht=curWwwPath.substring(0,pos);
            realPath=localhostPaht;
            //获取带"/"的项目名，如：/ahha
            if(isProjectName){
                var projectName = pathName.substring(0,pathName.substr(1).indexOf('/')+1);
                //得到了 服务器名称和项目名称
                realPath +=projectName;
            }
        }
        return realPath; 
    },
    isStringNullOrEmpty(str) {
        return ((str == undefined) || (str == null) || (str == ""));
    },
    setVisible(node, isVisible) {
        this.setVisibleEx(node, isVisible, 'block')
    },

    setVisibleEx(node, isVisible, displayValue) {
        if (node) {
            if (isVisible) {
                $(node).css({
                    'display': displayValue
                });
            }
            else {
                $(node).css({
                    'display': 'none'
                });
            }
        }
    },
    /**
     * ..Dean..20190626.对传入的数字，进行小数位数的格式化
     * @param value
     * @param fractionalDigits：小数位数
     */
    formatNumber(num, fractionalDigits){
        return num.toFixed(fractionalDigits);
    },
     /**
     * ..Dean..20190703.判断对象是否存在于数组中
     * @param key
     * @param value
     * @param array
     */
    isObjExistenceOfArray(key,value,array){
        for(var i= 0,l = array.length;i<l;i++){
            var item = array[i];
            if(item[key] == value){
                return true;
            }
        }
        return false;
    },

         /**
     * ..Dean..20190703.根据关键字获取指定数组的对象
     * @param key
     * @param value
     * @param array
     */
    getObjByKey(key,value,array){
        for (var prop in array) {
            if (array[prop][key] == value) {
                return array[prop];
            }
        }
        return null;
    },

    /**
     * ..Dean..20190703.将objB的所有属性及数据，合成至objA中
     * 注意：objB中如果存在与objA中相同的属性时，将会覆盖objA的
     * @param objA
     * @param objB
     */
    mixinObject(objA, objB) {
        if (objA && objB) {
            for (var prop in objB) {
                objA[prop] = objB[prop];
            }
        }
        return objA;
    },

    /**
     * ..Dean..20190710.不区分大小写，判断两字符串是否相同
     * @param strA
     * @param strB
     */
    isSameText(strA, strB) {
        if ((strA == null) && (strB == null)) {
            return true;
        }
        else {
            var strATemp = "";
            var strBTemp = "";
            if (strA != null) {
                strATemp = strA.toLowerCase();
            }
            if (strB != null) {
                strBTemp = strB.toLowerCase();
            }
            if (strATemp == strBTemp) {
                return true;
            }
        }
        return false;
    },
    /**
     * ..Dean..20190813.生成指定范围内的随机索引（整数）
     * @param minIndex
     * @param maxIndex
     * @returns {*}
     */
    makeRandomIndex(minIndex, maxIndex) {
        var range = maxIndex - minIndex;
        if (range == 0) {
            return 0;
        }
        else {
            var rand = Math.random();
            var num = minIndex + Math.round(rand * range); //四舍五入
            return num;
        }
    },
    //下面是生成最多maxCount个数
    makeRandomIndexArray(minIndex, maxIndex, maxCount) {
        var retArray = [];
        while (true) {
            var index = this.makeRandomIndex(minIndex, maxIndex);
            if (retArray.indexOf(index) < 0) {//不存在则加入
                retArray.push(index);
                if (retArray.length == maxCount) {//达到上限
                    break;
                }
            }
        }
        return retArray;
    },
}